import React from "react";
import moment from "moment";

import {component_tool} from '@/tool'

import {WizTableForm} from "@/containers/common";
import {Popover} from "antd";


const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } })
const pathStage = WizTableForm.Config.pathStage(this, { apiParams: { state: 1 } })

//配置项
const componentName = 'trainPathLearningScore';
const columns = (self) => {
  return [
    {
      title: '姓名',
      name: "fullName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: '账号',
      name: "userName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: '任职',
      name: "identityList",
      tableItem: {
        render: (text, record) => {
          const list = text?.length ? text?.map(item => {
            const {orgName, orgCode, positionName, positionCode} = item || {}
            return <>{orgName}({orgCode})-{positionName}</>
          }) : []

          return (
            list?.length ?
              <Popover content={list?.map(view => <div>{view}</div>)}>
                {list[0]}
                {list.length > 1 ? <span style={{color: '#1790FF'}}>&nbsp;…</span> : undefined}
              </Popover> : '暂无任职'
          )
        }
      },
      exportItem: {
        width: 100,
        render: (text) => {
          return text?.map(item => {
            const {orgName, orgCode, positionName, positionCode} = item || {}
            return `${orgName}(${orgCode})-${positionName}`
          })?.join('\r\n')
        },
      },
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      },
    },
    {
      title: "岗位名称",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      },
    },
    {
      title: "积分/状态",
      name: "dataValue",
      tableItem: {
        render: (text, record) => {
          const {pathType: dataType, dataValue} = record || {}
          if (dataType === 1) {
            return dataValue > 0 ? '合格' : '不合格'
          }
          return text
        }
      },
    },
    {
      title: "阶段类型",
      name: "type",
      dict: [
        {code: 0, codeName: '必修'},
        {code: 1, codeName: '选修'},
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "路径",
      name: "pathIds",
      searchItem: {
        ...path,
        diy: WizTableForm,
      },
      tableItem: {
        dataIndex: 'pathName',
      },
    },
    {
      title: "阶段",
      name: "stageIds",
      searchItem: {
        ...pathStage,
        modalProps: {
          destroyOnClose: true,
        },
        diy: WizTableForm,
      },
      tableItem: {
        dataIndex: 'stageName',
      },
    },
    {
      title: "完成任务说明",
      name: "#remark",
      tableItem: {
        render: (_, record) => {
          const {type, bizType, bizId, bizName} = record || {}
          if (type === 0) {
            return '阶段完成';
          }
          return `${({
            1: '在线课程',
            2: '在线考试',
            3: '线下培训',
            5: '评语',
            6: '课程组',
            7: '资讯',
            8: '作业',
          }[bizType] || bizType)}-${bizName || `${bizId}`}`
        }
      },
    },
  ];
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        // btnAccessCheck: false,
        columns: columns(self),
        searchBarProps: {
          cols: {
            xs: 8,
            md: 8,
            xl: 8
          },
          wrappedComponentRef: self._wizTableList_searchRef,
          // dataFormat: (v) => {
          //   const value = Object.assign({}, v)
          //   const {date} = value || {}
          //   value.date = value.date && moment(date).format('YYYY-MM')
          //   return value
          // },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        modalFormProps: {},
        rowOperateProps: {
          // width: 80,
        },
        rowOperateSort: [],
        rowOperateView: [],
        commonOperate: {}
      }
    }
  };
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {columns, reduxTemplateConfig, templateConfig};
